module.exports = __webpack_public_path__ + "static/media/qmas_logo_white_full.10b44ca9.png";